import { splitCamelCase } from '@Utils/helpers/stringHelpers';
import { Grow, TextField } from '@mui/material';
import _cloneDeep from 'lodash/cloneDeep';
import _isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import ProcessesApi from '@Data/processes/Api';
import AutomationTaskApi from '@Services/iiq/Api';
import AutomationTaskSelector from '../AutomationTaskSelector';
import Styles from '../Processes.scss';
import MultiFieldSelector from './MultiFieldSelector';

const ProcessPayloadForm = (props) => {
    const {
        payloadData,
        folderFields,
        automationTasks,
        selectedAutomationTaskUri,
    } = props;

    const [inputs, setInputs] = useState<Array<any>>([]);

    useEffect(() => {
        renderInputs();
    }, [payloadData, folderFields, automationTasks]);

    const renderInputs = () => {
        let inputsArray: Array<any> = [];
        if (!_isEmpty(payloadData)) {
            Object.keys(payloadData).forEach((key, i) => {
                const lcKey = key.toLowerCase();
                if (
                    lcKey.indexOf('project') === -1 &&
                    lcKey.indexOf('folder') === -1
                ) {
                    if (key === 'imageUrlFieldName') {
                        inputsArray = [
                            ...inputsArray,
                            <MultiFieldSelector
                                id={`${key}-multi-field-selector`}
                                key={`mfSelector${key}`}
                                fieldName={key}
                                folderFields={folderFields}
                                values={payloadData[key]}
                            />,
                        ];
                    } else if (key === 'automation_task') {
                        inputsArray = [
                            <div
                                key={`${i}${key}`}
                                className={Styles.spFolderInputs}
                            >
                                <div className={Styles.spFolderLabelContainer}>
                                    {splitCamelCase(key)}
                                </div>
                                <div className={Styles.spLeftMargin}>
                                    <AutomationTaskSelector
                                        id={`${key}-selector`}
                                        automationTasks={automationTasks}
                                        selectedAutomationTaskUri={
                                            selectedAutomationTaskUri
                                        }
                                        onSelectAutomationTask={(e) => {
                                            handleAutomationTaskChange(e);
                                        }}
                                    />
                                </div>
                            </div>,
                        ];
                    }
                } else {
                    const placeholder = Array.isArray(payloadData[key])
                        ? '[]'
                        : payloadData[key];

                    inputsArray = [
                        <div
                            key={`${i}${key}`}
                            className={Styles.spFolderInputs}
                        >
                            <div className={Styles.spFolderLabelContainer}>
                                {splitCamelCase(key)}
                            </div>
                            <div className={Styles.spLeftMargin}>
                                <TextField
                                    id={`${key}-text-field`}
                                    key={i}
                                    placeholder={placeholder.toString()}
                                    onChange={(e) => {
                                        handleInputChange(e, key);
                                    }}
                                    size="small"
                                    value={payloadData[key]}
                                    sx={{ width: 300 }}
                                />
                            </div>
                        </div>,
                        ...inputsArray,
                    ];
                }
            });
            setInputs(inputsArray);
        }
    };

    const handleInputChange = (event, field) => {
        ProcessesApi.OLDsetPayloadDataAttribute(field, event.target.value);
    };

    const handleAutomationTaskChange = (event) => {
        AutomationTaskApi.setAutomationTask(event);
        ProcessesApi.OLDsetPayloadDataAttribute(
            'automation_task',
            event.automationTaskUri
        );
    };

    return (
        <Grow in>
            <div id="process" className={Styles.spTopMarginDouble}>
                {inputs}
            </div>
        </Grow>
    );
};

ProcessPayloadForm.propTypes = {
    payloadData: PropTypes.object,
    onCancel: PropTypes.func,
    onSubmit: PropTypes.func,
    projectId: PropTypes.number,
    folderId: PropTypes.string,
    folderFields: PropTypes.array,
    automationTasks: PropTypes.array,
    selectedAutomationTaskUri: PropTypes.string,
    selectedFolderField: PropTypes.string,
    onSelectFolderField: PropTypes.func,
};
ProcessPayloadForm.defaultProps = {
    folderFields: [],
};
export default ProcessPayloadForm;
